import React, { useContext, useEffect, useState } from 'react';
import { Box, Paper, Tab, Tabs, Typography } from '@material-ui/core';

import { warehouseApi as api } from 'api/warehouse';
import { BulkCreateLocations } from 'components/warehouse/components/bulkCreateLocations';
import { ViewLocations } from 'components/warehouse/components/viewLocations';
import { UserContext } from 'contexts/UserContext';
import { TabPanel } from 'shared';

function LocationsV2({ baseUrl }) {
    const [selectedTab, setSelectedTab] = useState('0');
    const handleChange = (event, value) => {
        setSelectedTab(value);
    };
    const [v2Locations, setV2Locations] = useState(false);

    const user = useContext(UserContext);

    const getFacilities = async () => {
        const response = await api.getFacilities();
        if (response.status === false) {
            return;
        }

        const facilities = response.data.rows;
        for (const facility of facilities) {
            if (facility.id === user.getFacilityID()) {
                setV2Locations(facility.v2Locations);
            }
        }
    };

    useEffect(() => {
        getFacilities();
    }, []);

    return (
        <Paper>
            <Tabs onChange={handleChange} value={selectedTab} indicatorColor="primary" textColor="primary" centered>
                <Tab label="View Locations" value="0" />
                <Tab label="Create Locations" value="1" />
            </Tabs>
            <TabPanel selectedTab={selectedTab} index="0">
                <ViewLocations v2Locations={v2Locations} />
            </TabPanel>
            <TabPanel selectedTab={selectedTab} index="1">
                <BulkCreateLocations v2Locations={v2Locations} />
            </TabPanel>
        </Paper>
    );
}

export { LocationsV2 };
